"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A tiny observable implementation similar to a `BehaviourSubject`.
 * It is created with an initial value which is emitted on each
 * subscription.
 */
var Observable = /** @class */ (function () {
    function Observable(initialValue) {
        this.subscriptions = [];
        this.value = initialValue;
    }
    Observable.prototype.subscribe = function (subscriber) {
        var _this = this;
        this.subscriptions.push(subscriber);
        subscriber(this.value);
        return {
            unsubscribe: function () {
                var index = _this.subscriptions.indexOf(subscriber);
                _this.subscriptions.splice(index, 1);
            }
        };
    };
    Observable.prototype.next = function (value) {
        this.value = value;
        this.subscriptions.forEach(function (subscription) { return subscription(value); });
    };
    return Observable;
}());
exports.default = Observable;
//# sourceMappingURL=Observable.js.map